import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgAlertCircle = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 18,
	height: 18,
	viewBox: "0 0 18 18",
	...props,
	children: [/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsxs("filter", {
		id: "74exi7fuga",
		width: "123.6%",
		height: "126.1%",
		x: "-11.8%",
		y: "-13.1%",
		filterUnits: "objectBoundingBox",
		children: [
			/* @__PURE__ */ _jsx("feOffset", {
				dy: 2,
				in: "SourceAlpha",
				result: "shadowOffsetOuter1"
			}),
			/* @__PURE__ */ _jsx("feGaussianBlur", {
				in: "shadowOffsetOuter1",
				result: "shadowBlurOuter1",
				stdDeviation: 8
			}),
			/* @__PURE__ */ _jsx("feColorMatrix", {
				in: "shadowBlurOuter1",
				result: "shadowMatrixOuter1",
				values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
			}),
			/* @__PURE__ */ _jsxs("feMerge", { children: [/* @__PURE__ */ _jsx("feMergeNode", { in: "shadowMatrixOuter1" }), /* @__PURE__ */ _jsx("feMergeNode", { in: "SourceGraphic" })] })
		]
	}) }), /* @__PURE__ */ _jsx("g", {
		fill: "none",
		fillRule: "evenodd",
		children: /* @__PURE__ */ _jsx("g", {
			fill: "#FF7538",
			children: /* @__PURE__ */ _jsx("g", {
				filter: "url(#74exi7fuga)",
				transform: "translate(-1099 -207) translate(1072 128)",
				children: /* @__PURE__ */ _jsx("g", { children: /* @__PURE__ */ _jsx("g", { children: /* @__PURE__ */ _jsx("g", { children: /* @__PURE__ */ _jsx("path", {
					d: "M9 .75c4.556 0 8.25 3.694 8.25 8.25S13.556 17.25 9 17.25.75 13.556.75 9 4.444.75 9 .75zm0 1.5C5.272 2.25 2.25 5.272 2.25 9S5.272 15.75 9 15.75s6.75-3.022 6.75-6.75S12.728 2.25 9 2.25zm-.53 8.47c.293-.293.767-.293 1.06 0 .293.293.293.767 0 1.06-.293.293-.767.293-1.06 0-.293-.293-.293-.767 0-1.06zM9 5.25c.414 0 .75.336.75.75v3c0 .414-.336.75-.75.75s-.75-.336-.75-.75V6c0-.414.336-.75.75-.75z",
					transform: "translate(20 56) translate(0 16) translate(7 7)"
				}) }) }) })
			})
		})
	})]
});
export default SvgAlertCircle;
